export function trimSearch(searchText) {
  return !searchText
    ? ''
    : searchText
        .split(' ')
        .filter(part => part.length > 0)
        .join(' ');
}
